import {combineReducers} from 'redux';
import {AdminAuthRiderReducer} from '../../../../components/adminSignIn/store/reducers/aminAuthReducer'
const reducer = combineReducers({
 AdminAuthRiderReducer 
    });
    
    export default reducer;
